import {createSlice} from "@reduxjs/toolkit"
import apiService from "../../api/apiService";
import {formatAxiosErrorMessage} from "../../utils/common";
import {endPoints} from "../../api/endpoints";
import {apiUrlBuilder} from "../../utils/util";


const PaymentIntegrationInitialState = {
    configuration: {
        isLoading: false,
        data: null,
        error: null,
    },
    createConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
    deleteConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
}

export const PaymentSlice = createSlice({
    name: "paymentintegration",
    initialState: {
        ...PaymentIntegrationInitialState
    }, reducers: {
        PaymentConfigurationRequesting: (state, action) => {
            state.configuration.isLoading = true
        },
        PaymentConfigurationSuccess: (state, action) => {
            state.configuration.isLoading = false
            state.configuration.error = null
            state.configuration.data = action.payload?.data ?? action.payload ?? []
        },
        PaymentConfigurationError: (state, action) => {
            state.configuration.isLoading = false
            state.configuration.error = action.payload
        },
        PaymentConfigurationReset: (state, action) => {
            state.configuration = PaymentIntegrationInitialState.configuration
        },

        PaymentCreateConfigurationRequesting: (state, action) => {
            state.createConfiguration.isLoading = true
        },
        PaymentCreateConfigurationSuccess: (state, action) => {
            state.createConfiguration.isLoading = false
            state.createConfiguration.error = null
            state.createConfiguration.data = action.payload.data
        },
        PaymentCreateConfigurationError: (state, action) => {
            state.createConfiguration.isLoading = false
            state.createConfiguration.error = action.payload
        },
        PaymentCreateConfigurationReset: (state, action) => {
            state.createConfiguration = PaymentIntegrationInitialState.createConfiguration
        },

        PaymentDeleteConfigurationRequesting: (state, action) => {
            state.deleteConfiguration.isLoading = true
        },
        PaymentDeleteConfigurationSuccess: (state, action) => {
            state.deleteConfiguration.isLoading = false
            state.deleteConfiguration.error = null
            state.deleteConfiguration.data = "deleted"
        },
        PaymentDeleteConfigurationError: (state, action) => {
            state.deleteConfiguration.isLoading = false
            state.deleteConfiguration.data = null
            state.deleteConfiguration.error = action.payload
        },
        PaymentDeleteConfigurationReset: (state, action) => {
            state.deleteConfiguration = PaymentIntegrationInitialState.deleteConfiguration
        },
    }
})

export const PaymentConfigurationAPI = () => async dispatch => {
    dispatch(PaymentConfigurationRequesting());
    apiService
    .get(endPoints.integration.payment.config, {})
    .then((response) => {
        dispatch(PaymentConfigurationSuccess(response.data))
    })
    .catch((error) => dispatch(PaymentConfigurationError(formatAxiosErrorMessage(error))));
}

export const PaymentCreateConfigurationAPI = (data) => async dispatch => {
    dispatch(PaymentCreateConfigurationRequesting());
    apiService
    .post(apiUrlBuilder(endPoints.integration.payment.config, null, {}), data)
    .then((response) => {
        dispatch(PaymentCreateConfigurationSuccess(response.data))
    })
    .catch((error) => dispatch(PaymentCreateConfigurationError(formatAxiosErrorMessage(error))));
}

export const PaymentDeleteConfigurationAPI = (id, force = false) => async dispatch => {
    dispatch(PaymentDeleteConfigurationRequesting());
    apiService
    .delete(
        apiUrlBuilder(`integration/${id}/payment/config/`, null, {force}),
        {}
    )
    .then((response) => {
        dispatch(PaymentDeleteConfigurationSuccess(response.data))
    })
    .catch((error) => dispatch(PaymentDeleteConfigurationError(formatAxiosErrorMessage(error))));
}

export const {

    PaymentConfigurationRequesting,
    PaymentConfigurationSuccess,
    PaymentConfigurationError,
    PaymentConfigurationReset,

    PaymentCreateConfigurationRequesting,
    PaymentCreateConfigurationSuccess,
    PaymentCreateConfigurationError,
    PaymentCreateConfigurationReset,

    PaymentDeleteConfigurationRequesting,
    PaymentDeleteConfigurationSuccess,
    PaymentDeleteConfigurationError,
    PaymentDeleteConfigurationReset,

    PaymentResetState

} = PaymentSlice.actions;
export const PaymentState = (state) => state.paymentIntegration
export default PaymentSlice.reducer
